import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient, HttpRequest } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Globals } from '../globals';
import { map, catchError } from "rxjs/operators";
import { ConfigurationsService } from 'src/app/Service/configurations.service';


@Injectable({
    providedIn: 'root'
})

export class GSMConfigurationService {
    private httpHeader = new HttpHeaders();

    constructor(private http: HttpClient, private _global: Globals, private configService: ConfigurationsService) {
        this.httpHeader.append('Access-Control-Allow-Origin', '*');
    }

    // Method is used for get dropdown list of configpage
    Getdropdownlist(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetAllCodeCommonDropdownlist?CategoryName=' + ReqObj;
        return this.http.get(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for get data of configpage by GSM keyID
    GetGSMConfigdata(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetGSMConfigdata?DevicetypeID=' + ReqObj;
        return this.http.get(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    GetRTCdata(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetRTCSettingData?DeviceTypeID=' + ReqObj;
        return this.http.get(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    GetMQTTSettingData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetMQTTSettingData?DeviceTypeID=' + ReqObj;
        return this.http.get(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    GetRegisterdata(ReqObj: any, ForReport: any, ForUserControl: any, IsFromParameterConfigData: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetRegisterData?EnergymeterMasterID=' + ReqObj + '&ForReport=' + ForReport + '&ForUserControl=' + ForUserControl + '&IsFromParameterConfigData=' + IsFromParameterConfigData;
        return this.http.get(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    GetMeterConfigurationData(MeterId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetMeterConfigurationData?EnergymeterMasterId=' + MeterId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    GetVirtualFormulaData(selectedregister: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/GetVirtualFormulaData?VirtualRegister=' + selectedregister
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    GetEthernetdata(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/EthernetTcpSettings?DeviceTypeID=' + ReqObj;
        return this.http.get(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    // Method is used for save data of configpage
    SaveGSMConfigdata(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/SaveGSMConfigData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    SaveEthernetConfigdata(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/SaveEthernetTcpSettings';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    // Method is used for save Register Data
    SaveRegisterData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/SaveRegisterData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for save Virtual Register Data
    SaveVirtualRegisterData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/SaveVirtualRegisterData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    // Method is used for save Register Data
    SaveRegisterThresoldvalue(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/SaveRegisterThresoldvalue';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for save RTC Data
    SaveRTCSettingData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/SaveRTCSettingData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    SaveMeterConfigurationData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/SaveMeterConfigurationData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    // Method is used for save MQTT Settings Data
    SaveMQTTSettingData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/SaveMQTTSettingData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
}
